// src/components/Header.jsx
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';

export default function Header() {
  const nav = useNavigate();
  const logout = () => {
    localStorage.removeItem('token');
    nav('/login');
  };

  return (
    <header className="flex items-center justify-between px-6 py-4 text-[#1F2A44] 
                       shadow-lg rounded-b-lg mb-6">
     <h2 className="text-2xl font-semibold">Promo Management System</h2>
     <Button
       label="Logout"
       icon="pi pi-sign-out"
       onClick={logout}
       className="p-button-text text-[#1F2A44] hover:text-[#FFD700]"
     />
   </header>
  );
}